import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import classes from 'components/BetterList/List.scss'

import ListColumn from 'components/BetterList/Column'

export const AfterOrderRow = ({ mapArguments, options }) => {
  let [order, rowIndex] = mapArguments

  if (!order.notes) return null

  return <tr className={cx(
    classes['item--after'],
    options.includes('striped') && classes['item--striped']
  )}>
    <ListColumn key={`row-${rowIndex}:order.notes`} options={['full-width', 'notes']} colspan={100}>
      <i>Notes:</i> {order.notes}
    </ListColumn>
  </tr>
}

AfterOrderRow.propTypes = {
  mapArguments: PropTypes.array.isRequired,
  options: PropTypes.array
}

export default AfterOrderRow



// WEBPACK FOOTER //
// ./src/components/Orders/List/AfterRow.js